/**
 * View do resultado do upload de planilha para pedido.
 * Exibe: pedido criado, SKU não encontrado, Lote não encontrado, sem estoque, pendentes.
 */
export default (result, orderType = 'output') =>
{
	const { order_id, sku_nao_encontrado = [], lote_nao_encontrado = [], sem_estoque = [], pendentes = [] } = result || {};
	const parts = [];

	if (order_id)
		parts.push(`<p class="mts"><strong>Pedido #${order_id}</strong> criado.</p>`);
	else if (orderType === 'output' && (sku_nao_encontrado?.length || lote_nao_encontrado?.length || sem_estoque?.length || pendentes?.length))
		parts.push(`<p class="mts">Nenhum item pôde ser incluído no pedido (todos SKU não encontrados, lote não encontrado ou sem estoque).</p>`);
	else if (orderType === 'input' && sku_nao_encontrado?.length)
		parts.push(`<p class="mts">Nenhum item pôde ser incluído no pedido (todos SKU não encontrados).</p>`);

	if (sku_nao_encontrado?.length)
	{
		parts.push(`<p class="mtm"><strong>SKU não encontrado</strong>:</p>`);
		parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Quantidade</th><th>Lote</th><th>Vlr</th></tr></thead><tbody>`);
		sku_nao_encontrado.forEach(r =>
			parts.push(`<tr><td>${r.sku || ''}</td><td>${r.quantidade ?? ''}</td><td>${r.lote ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`)
		);
		parts.push(`</tbody></table>`);
	}

	if (orderType === 'output' && lote_nao_encontrado?.length)
	{
		parts.push(`<p class="mtm"><strong>Lote não encontrado</strong>:</p>`);
		parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Quantidade</th><th>Vlr</th></tr></thead><tbody>`);
		lote_nao_encontrado.forEach(r =>
			parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.quantidade ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`)
		);
		parts.push(`</tbody></table>`);
	}

	if (sem_estoque?.length)
	{
		parts.push(`<p class="mtm"><strong>Sem estoque</strong>:</p>`);
		parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
		sem_estoque.forEach(r =>
			parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? 0}</td><td>${r.pendente ?? ''}</td></tr>`)
		);
		parts.push(`</tbody></table>`);
	}

	if (pendentes?.length)
	{
		parts.push(`<p class="mtm"><strong>Pendente</strong> (parcial):</p>`);
		parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
		pendentes.forEach(r =>
			parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? ''}</td><td>${r.pendente ?? ''}</td></tr>`)
		);
		parts.push(`</tbody></table>`);
	}

	return parts.join('') || '<p class="mts">Processamento concluído.</p>';
};
